import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-12 py-16 md:py-24 bg-background-100 text-center">
      <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 mb-4">
        准备好开启追番之旅了吗？
      </h2>
      <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-xl mx-auto">
        加入51动漫，发现更多精彩国产动漫。每日更新，追番不停，精彩内容尽在掌握。
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/category/guoman"
          className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap inline-flex items-center gap-2"
        >
          立即探索 <i className="ri-arrow-right-line"></i>
        </Link>
        <Link
          to="/about"
          className="px-8 py-3.5 rounded-lg border border-foreground-300 text-foreground-700 font-medium text-sm hover:bg-background-50 transition-colors whitespace-nowrap"
        >
          了解更多
        </Link>
      </div>

      <div className="mt-12 flex items-center justify-center flex-wrap gap-6 md:gap-10 opacity-40">
        <span className="text-sm font-medium text-foreground-600">腾讯视频</span>
        <span className="text-sm font-medium text-foreground-600">哔哩哔哩</span>
        <span className="text-sm font-medium text-foreground-600">优酷</span>
        <span className="text-sm font-medium text-foreground-600">爱奇艺</span>
        <span className="text-sm font-medium text-foreground-600">芒果TV</span>
      </div>
    </section>
  );
}